import { AfterContentChecked, AfterViewInit, Component, ErrorHandler, HostListener, OnInit, ViewChild, ChangeDetectionStrategy, signal } from '@angular/core'
import { form, required } from '@angular/forms/signals'
import { Router } from '@angular/router'
import { FormValidationService } from '../_jaettu-angular/service/form-validation.service'

import { MatDialog } from '@angular/material/dialog'
import { MatInput } from '@angular/material/input'

import { validoiReaktiivisesti } from '../_jaettu-angular/_lomakkeet/reaktiivinen-validaattori'
import { LadataanService } from '../_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from '../_jaettu-angular/service/lemon-translation.service'

import { VaihdaSalasanaPyynto, VaihdaSalasanaVastaus } from '@lemon/core-firebase/model/common'
import { LemonaidValidators } from 'app/_angular/_validator/LemonaidValidators'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { VaihdaKieliDialog, VaihdaKieliDialogData } from '../vaihda-kieli.dialog'

@Component({
  templateUrl: './change.component.html',
  styleUrls: ['./login.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChangeComponent implements OnInit, AfterViewInit, AfterContentChecked {
  @ViewChild('oldpassword', { read: MatInput, static: true }) oldPasswordInput: MatInput

  // Kentät ovat omia lomakkeitaan, jotta selaimen salasanakentille tutut nimet säilyvät: ryhmän kenttien nimet ovat muotoa lomake.kentta
  vanhaSalasana = form(signal(''), polku => required(polku), { name: 'current-password' })
  uusiSalasana = form(
    signal(''),
    polku => {
      required(polku)
      validoiReaktiivisesti(polku, LemonaidValidators.passwordComplexityValidator)
    },
    { name: 'new-password' },
  )
  readonly commonError = signal<string | null>(null)
  success = false
  virheet: any = {}
  year = new Date().getFullYear()

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private validationService: FormValidationService,
    private errorHandler: ErrorHandler,
    private ladataanService: LadataanService,
    private translationService: LemonTranslationService,
    private _firebaseLemonaid: FirebaseLemonaid,
  ) {}

  ngAfterContentChecked() {
    const pwdField = this.uusiSalasana
    if (pwdField) {
      this.virheet = Object.fromEntries(
        pwdField()
          .errors()
          .map(virhe => [virhe.kind, true]),
      )
    }
    this.virheet = {}
  }

  ngOnInit(): void {}

  onkoLomakeKelvollinen() {
    return this.vanhaSalasana().valid() && this.uusiSalasana().valid()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.oldPasswordInput.focus()
    }, 0)
  }

  @HostListener('document:keydown.esc')
  back() {
    this.router.navigate(['/'])
  }

  @HostListener('document:keydown.enter')
  defaultAction() {
    this.changePassword()
  }

  changePassword() {
    if (!this.onkoLomakeKelvollinen()) {
      this._merkitseKosketuksi()
      return
    }

    this.ladataanService.aloitaLataaminen()

    const data: VaihdaSalasanaPyynto = {
      uusiSalasana: this.vanhaSalasana().value(),
      vanhaSalasana: this.uusiSalasana().value(),
    }

    this._firebaseLemonaid
      .functionsCall<VaihdaSalasanaPyynto, VaihdaSalasanaVastaus>('vaihdaSalasana', data)
      .then(vastaus => {
        this.ladataanService.lopetaLataaminen()
      })
      .catch(err => {
        this.kasitteleVirhe(err)
        this.ladataanService.lopetaLataaminen()
      })
  }

  private kasitteleVirhe(err: any) {
    const code = err.code
    if (code) {
      switch (code) {
        case 'auth/expired-action-code':
          this.commonError.set(this.translationService.lokalisoi('reset.virheet.koodi-vanhentunut'))
          break
        case 'auth/invalid-action-code':
          this.commonError.set(this.translationService.lokalisoi('reset.virheet.koodi-ei-oikea'))
          break
        case 'auth/user-disabled':
          this.commonError.set(this.translationService.lokalisoi('reset.virheet.kayttaja-inaktiivinen'))
          break
        case 'auth/user-not-found':
          this.commonError.set(this.translationService.lokalisoi('reset.virheet.kayttaja-ei-loydy'))
          break
        case 'auth/weak-password':
          this.commonError.set(this.translationService.lokalisoi('reset.virheet.salasana-heikko'))
          break
        default:
          this.commonError.set(this.translationService.lokalisoi('yleiset.tuntematon-virhe'))
          this.errorHandler.handleError(err)
      }
      this.ngAfterContentChecked()
      this._merkitseKosketuksi()
    } else {
      this.commonError.set(this.translationService.lokalisoi('yleiset.tuntematon-virhe'))
      this.errorHandler.handleError(err)
    }
  }

  private _merkitseKosketuksi() {
    this.vanhaSalasana().markAsTouched()
    this.validationService.merkitseKokoLomakeKosketuksi(this.uusiSalasana)
  }

  vaihdaKieli() {
    const data: VaihdaKieliDialogData = {
      tallenna: false,
    }
    this.dialog.open(VaihdaKieliDialog, { data: data })
  }
}
